import { Component, OnInit } from '@angular/core';
import { PlatformWidgetComponent } from '../platform-widget.component';
import { BehaviorSubject, firstValueFrom, Observable, Subject } from 'rxjs';
import { BookingService } from '@markant-platform/cartridge/data-access';
import { SnackbarService } from '@markant-platform/shared/snackbar/feature';
import { ContactRequestsDto } from '@markant-platform/cartridge/model';

@Component({
  selector: 'markant-platform-contact-requests-widget',
  templateUrl: 'contact-requests-widget.component.html',
})
export class ContactRequestsWidgetComponent extends PlatformWidgetComponent implements OnInit {
  private readonly _loading: Subject<boolean> = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean> = this._loading.asObservable();
  request: ContactRequestsDto = {
    openNegotiationRequests: 0,
    inProgressNegotiationRequests: 0,
  };

  constructor(
    private bookingService: BookingService,
    private snackbarService: SnackbarService
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    try {
      this.request = await firstValueFrom(this.bookingService.getNegotiationRequestsCount());
      this._loading.next(false);
    } catch (error) {
      this.snackbarService.showErrorSnackbarWithTransloco('platformWidget.admin.platformRequests.cannotLoadWidgetData');
    }
  }
}
